import { GlBadge, GlPopover, GlLink, GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { helpPagePath } from '~/helpers/help_page_helper';
export default {
    name: 'CiCatalogBadge',
    components: {
        GlBadge,
        GlPopover,
        GlLink,
        GlSprintf
    },
    props: {
        isPublished: {
            type: Boolean,
            required: false,
            default: false
        },
        exploreCatalogPath: {
            type: String,
            required: false,
            default: ''
        }
    },
    ciCatalogBadgePopoverHelpLink: helpPagePath('ci/components/_index.md', {
        anchor: 'publish-a-new-release'
    })
};
